module.exports = __webpack_public_path__ + "static/img/170.15c6223.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/170.jpg
// module id = MWes
// module chunks = 5